import { Component, OnInit } from '@angular/core';
import { GridBaseCase } from '../grid.base.case';
import { WebParameterContext } from '../../../../model/common';
import { Platform } from '@ionic/angular';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageclientService } from 'src/service/messageclient.service';
import { CommonService } from 'src/service/common.service';
import {HandleWebParameterContextBeforeDBRequest,HandleServerContextAfterDBRequest} from '../../../../bizlogic/servicesbll';

declare var app;


@Component({
  selector: 'app-mz-grid-order',
  templateUrl: './mz-grid-order.component.html',
  styleUrls: ['./mz-grid-order.component.scss']
})
export class MzGridOrderComponent extends GridBaseCase {
  dataArrayList: Array<any> = [];
  constructor(
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private router: Router,
    private platform:Platform,
    private msg: MessageclientService,
    private com : CommonService
  ) { super(); }

  ngOnInit() {
    this.LoadData();
  }
  LoadData() {
    const that = this;
    that.loading = false;
    that.apiObj['status'] = false;
    that.apiObj['msg'] = '';
    const pageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    const id = that.activaRouter.snapshot.paramMap.get('id');
    let body: WebParameterContext = new WebParameterContext();
    if (that.element.selectItemList.gridViewConfigName) {
      body.ConfigName = that.element.selectItemList.gridViewConfigName;
    } else if (that.ConfigName) {
      body.ConfigName = that.ConfigName;
    }
    body.Account = that.com.GetAccount;
    body.ID = id;
    body.OpType = "query";
    body.ConfigType = "view";
    body.Client.PageName = pageName;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    body = HandleWebParameterContextBeforeDBRequest(body);
    if(!body.ResponseMessage.Success){
      that.msg.Alert(body.ResponseMessage.ErrorMessage);
      return;
    }
    that.http.post(app.DEFAULTURL, body).then(data => {
      setTimeout(function () {
        that.apiObj['status'] = data.ResponseMessage.Success;
        that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
        that.loading = true;
      });
      data = HandleServerContextAfterDBRequest(body,data);
      // console.log("1000101111100011111111");
      that.dataArrayList = [];
      if (data.ResponseMessage.Success) {
        data.Status.Datas.forEach(function (item) {
          let objfield = {};
          that.element.selectItemList.selectItem.forEach((element,index)=>{
            if (element.bindingField) {
              objfield[element.bindingField] = item[element.field];
            }
          });
          that.dataArrayList.push(objfield);
        });
        console.log(that.dataArrayList,'that.dataArrayList');
      }
    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
      that.loading = true;
      console.log(error);
    })
  }

  EventLink(ev: any, parms: any) {
    let evs = ev.url || '';
    if (evs.trim() && parms) {
      if (evs.indexOf("http") > 0) {
        // this.router.navigateByUrl(evs);
        this.com.Go(evs);
      } else {
        // localStorage.setItem('element',JSON.stringify(ev));
        this.com.setHistoryUrl();
        // this.router.navigateByUrl(evs+"/query/"+ parms.id);
        this.com.Go(evs+"/query/"+ parms.id);
      }
    }

  }

  /**
   * 下拉刷新数据
   * @param event
   */
  doRefresh(event){
    this.LoadData();
    event.target.complete();
  }

}
